/**
 * Turn an upload failure into something the person uploading can act on.
 *
 * Documents go straight from the browser to storage, so a rejected request
 * carries no response the browser is allowed to read and axios reports the bare
 * string "Network Error". That was shown verbatim beside a progress bar frozen
 * at 0% — it named no cause and offered no next step, and the only conclusion
 * available was that your own connection had failed.
 *
 * Shared by the tutor application and the tutor settings page, which upload the
 * same documents to the same place and used to describe the same failure in two
 * different ways.
 */
export function describeUploadFailure(error, fallback = 'Upload failed') {
    if (error.response?.data?.message) {
        return error.response.data.message
    }

    if (error.response?.status === 413) {
        return 'That file is too large to upload. Please use a file under 10MB.'
    }

    if (!error.response) {
        return 'We could not reach the document store, so nothing was uploaded. Please check your connection and try again — if it keeps happening, contact us and we will sort it out.'
    }

    return error.message || fallback
}
